import '.b8{flex-shrink:0;}.ssr-plugin'
import '.w{padding:1rem;}.ssr-plugin'
import '.ab{width:100%;}.ssr-plugin'
import '.br{height:100%;}.ssr-plugin'
import '.ay{border:none;}.ssr-plugin'
import '.az{background-color:transparent;}.ssr-plugin'
import '.ev{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.dq{position:sticky;}.ssr-plugin'
import '.ew{top:4rem;}.ssr-plugin'
import '.ex{z-index:7;}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.ey{padding-bottom:1rem;}.ssr-plugin'
import '.y{margin-bottom:1rem;}.ssr-plugin'
import '.ez{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a6{position:fixed;}.ssr-plugin'
import '.cv{top:0;}.ssr-plugin'
import '.bp{left:0px;}.ssr-plugin'
import '.bq{right:0px;}.ssr-plugin'
import '.f0{bottom:0px;}.ssr-plugin'
import '.f1{z-index:9999;}.ssr-plugin'
import '.f2{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.da{justify-content:flex-end;}.ssr-plugin'
import '.ci{flex:1;}.ssr-plugin'
import '.ai{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="b8 w ab br ay az ev"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ae"
    >
      <div className="dq ew ex ah ey y ez a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a6 cv bp bq f0 f1 ah f2 a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="w a da ez"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ci ai">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
